module.exports = __webpack_public_path__ + "img/OBSstudio.c3db4f03.png";